export class Status {
  stat = 0;
  msg = "";
}
